import { ApplicationConfig, isDevMode } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  ActionReducer,
  MetaReducer,
  provideState,
  provideStore,
} from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';

import { NotificationsEffects } from '@stores/notifications.effects';
import { notificationsReducer } from '@stores/notifications.reducer';
import { PlutoEffects } from '@stores/pluto.effects';
import { plutoReducer } from '@stores/pluto.reducer';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { localStorageSync } from 'ngrx-store-localstorage';
import { clientReducer } from '@stores/client.reducer';

export const keysToSave: string[] = [
  'loginData',
  'loginType',
  'walletBalance',
  'stakeBalance',
  // 'signer',
];

export function localStorageSyncReducer(
  reducer: ActionReducer<any>,
): ActionReducer<any> {
  return localStorageSync({
    keys: keysToSave,
    rehydrate: true,
    removeOnUndefined: true,
  })(reducer);
}

const metaReducers: MetaReducer[] = [localStorageSyncReducer];

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(),
    provideAnimationsAsync(),
    provideStore(),
    provideState('pluto', plutoReducer, { metaReducers }),
    provideEffects(PlutoEffects),
    provideState('notifications', notificationsReducer),
    provideEffects(NotificationsEffects),
    provideState('client', clientReducer),
    provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() }),
  ],
};
